import cx from "classnames";
import { FC, ReactNode, SVGProps } from "react";
import { NavLink } from "react-router-dom";

/**
 * Shared look for the desktop side rails (account, wallet).
 *
 * Kept in one place so the two rails stay visually identical — they are the
 * same idea applied to two sections.
 */
export const navRailItemClass = (isActive: boolean) =>
  cx(
    "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left text-body2 transition-colors",
    isActive
      ? "bg-brand-color/10 text-brand-color"
      : "text-primary hover:bg-background-two hover:text-primary",
  );

export const NavRailIcon = ({ svg: Svg }: { svg: FC<SVGProps<SVGSVGElement>> }) => (
  <Svg className="h-5 w-5 shrink-0 fill-[theme(textColor.secondary)]" />
);

export const NavRailLink = ({
  to,
  children,
  notify,
}: {
  to: string;
  children: ReactNode;
  /** Shows the same "something new here" dot the phone tabs use. */
  notify?: boolean;
}) => (
  <NavLink to={to} className={({ isActive }) => navRailItemClass(isActive)}>
    <span className="flex-1">{children}</span>
    {notify && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-color" />}
  </NavLink>
);
